import React from 'react';

export default function StairsMech() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0001 30.7218C24.1309 30.7218 30.7223 24.1304 30.7223 15.9996C30.7223 7.86871 24.1309 1.27734 16.0001 1.27734C7.86919 1.27734 1.27783 7.86871 1.27783 15.9996C1.27783 24.1304 7.86919 30.7218 16.0001 30.7218Z"
        fill="white"
        stroke="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8889 12C15.748 12 16.4444 12.597 16.4444 13.3333L16.4444 17.7778C16.4444 18.5142 15.748 19.1111 14.8889 19.1111C14.0299 19.1111 13.3335 18.5142 13.3335 17.7778L13.3335 13.3333C13.3335 12.597 14.0299 12 14.8889 12Z"
        fill="black"
      />
      <path
        d="M16.4444 9.55545C16.4444 10.4145 15.748 11.1109 14.8889 11.1109C14.0299 11.1109 13.3335 10.4145 13.3335 9.55545C13.3335 8.6964 14.0299 8 14.8889 8C15.748 8 16.4444 8.6964 16.4444 9.55545Z"
        fill="black"
      />
      <path
        d="M25.8033 12.6405C25.8033 13.7882 24.7834 14.7381 23.5254 14.7381H22.2666L13.8745 23.1102H10.2779C9.01983 23.1102 8 22.1798 8 21.0321C8 19.8845 9.01983 18.9541 10.2779 18.9541H12.196L20.6782 10.5625H23.5254C24.7834 10.5625 25.8033 11.4929 25.8033 12.6405Z"
        fill="white"
      />
      <path
        d="M22.2666 14.7381V14.2381C22.1342 14.2381 22.0072 14.2906 21.9134 14.3841L22.2666 14.7381ZM13.8745 23.1102V23.6102C14.0069 23.6102 14.1339 23.5577 14.2276 23.4641L13.8745 23.1102ZM12.196 18.9541V19.4541C12.3277 19.4541 12.4541 19.4021 12.5477 19.3095L12.196 18.9541ZM20.6782 10.5625V10.0625C20.5465 10.0625 20.4201 10.1144 20.3265 10.2071L20.6782 10.5625ZM23.5254 15.2381C25.0216 15.2381 26.3033 14.1008 26.3033 12.6405H25.3033C25.3033 13.4756 24.5452 14.2381 23.5254 14.2381V15.2381ZM22.2666 15.2381H23.5254V14.2381H22.2666V15.2381ZM21.9134 14.3841L13.5213 22.7562L14.2276 23.4641L22.6197 15.092L21.9134 14.3841ZM10.2779 22.6102C9.25178 22.6102 8.5 21.8614 8.5 21.0321H7.5C7.5 22.4982 8.78788 23.6102 10.2779 23.6102V22.6102ZM8.5 21.0321C8.5 20.2028 9.25178 19.4541 10.2779 19.4541V18.4541C8.78788 18.4541 7.5 19.5661 7.5 21.0321H8.5ZM10.2779 19.4541H12.196V18.4541H10.2779V19.4541ZM12.5477 19.3095L21.0298 10.9179L20.3265 10.2071L11.8444 18.5986L12.5477 19.3095ZM23.5254 10.0625H20.6782V11.0625H23.5254V10.0625ZM26.3033 12.6405C26.3033 11.1745 25.0153 10.0625 23.5254 10.0625V11.0625C24.5515 11.0625 25.3033 11.8113 25.3033 12.6405H26.3033ZM13.8745 22.6102H10.2779V23.6102H13.8745V22.6102Z"
        fill="black"
      />
    </svg>
  );
}
